import TheMap from '$src/housingCorporations/TheMap'
import EditCommentModal from '$src/housingCorporations/EditCommentModal'
import EditLocationModal, {
  coordinatesToETRS,
} from '$src/housingCorporations/EditLocationModal'
import EditNameModal from '$src/housingCorporations/EditNameModal'
import EditAddressModal from '$src/housingCorporations/EditAddressModal'
import EditMunicipalityModal from '$src/housingCorporations/EditMunicipalityModal'
import getHousingCorporations, {
  HousingCorporationsListResult,
} from '$src/api/endpoints/housingCorporations/getHousingCorporations'
import {Component, React, observer} from '$src/handy'
import * as css from './HousingCorporationsListPage.css'
import PageLayout from '$src/common/PageLayout/PageLayout'
import {keyBy} from 'lodash'
import {applySnapshot, getSnapshot} from 'mobx-state-tree'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import {Link, withRouter, RouteComponentProps} from 'react-router-dom'
import GenericButton from '$src/common/GenericButton'
import deepEqual from 'deep-equal'
import {
  defaultFilterMethod,
  booleanFilterMethod,
} from '$src/comparableSales/TableOfComparableSales'
import exportProjectToSpreadsheet from './exportProjectToSpreadsheet'
import AddItemModal from './AddItemModal'
import {HousingCorporation} from '$src/bootstrap/Store'
import editHousingCorporationHiddenState from '$src/api/endpoints/housingCorporations/editHousingCorporationHiddenState'

export const loadHousingCorporations = async (
  env: Component<$IntentionalAny, $IntentionalAny>,
  projectId: string,
) => {
  const result: HousingCorporationsListResult = await env.callEndpoint(
    getHousingCorporations,
    {projectId},
  )

  const list = result.map(s => s._id)
  const byId = keyBy(result, '_id')

  applySnapshot(env.store.housingCorporations.byId as $LibBugAny, byId)
  applySnapshot(env.store.housingCorporations.list as $LibBugAny, list)
}

interface State {
  loading: boolean
  error: undefined | string
  loaded: boolean
  mode:
    | {mode: 'AddItemModal'}
    | {mode: 'EditLocation'; cid: number}
    | {mode: 'EditComment'; cid: number}
    | {mode: 'EditName'; cid: number}
    | {mode: 'EditAddress'; cid: number}
    | {mode: 'EditMunicipality'; cid: number}
    | {mode: 'List'}
  hoveredItemIds: {[id: number]: true}
  activeItemIds: {[id: number]: true}
  exporting: boolean
  submitting: boolean
  optimisticState: null | boolean
  viewAllItems: boolean
}

interface Props extends RouteComponentProps<any> {}
interface HousingCorporationProps {
  housingCorporation: typeof HousingCorporation.Type
}

const defaultPageSize = 100

const baseSessionStorageKey = (projectId: number) =>
  `nsc/project(${projectId})/housingCorporationsList/`
const pageSizeSessionStorageKey = (projectId: number) =>
  baseSessionStorageKey(projectId) + `pageSize`
const filteredSessionStorageKey = (projectId: number) =>
  baseSessionStorageKey(projectId) + 'filtered'
const sortedSessionStorageKey = (projectId: number) =>
  baseSessionStorageKey(projectId) + 'sorted'

type Filtered = Array<{id: string; value: string}>
type Sorted = Array<{id: string; desc: boolean}>

type Original = {
  original: {
    _id: string
    hidden: boolean
    name: string
    address: string
    municipality: string
    location: {lat: number; long: number}
    comment: string
  }
}

// @ts-ignore
@withRouter
@observer
export default class HousingCorporationsListPage extends Component<
  {history: any},
  Props,
  State
> {
  tableInstance: ReactTable<$FixMe>
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      loading: false,
      error: undefined,
      loaded: false,
      mode: {mode: 'List'},
      hoveredItemIds: {},
      activeItemIds: {},
      exporting: false,
      submitting: false,
      optimisticState: null,
      viewAllItems: false,
    }
  }

  setTableInstance = (instance: ReactTable<$FixMe>) => {
    this.tableInstance = instance
  }

  UNSAFE_componentWillMount() {
    this.loadStuff()
  }

  getProjectId(props: Props = this.props) {
    return props.match.params.id
  }

  getProjectName(props: Props = this.props) {
    return props.match.params.name
  }

  getHousingCorporation(id: string): typeof HousingCorporation.Type {
    return this.store.housingCorporations.byId.get(
      id,
    ) as typeof HousingCorporation.Type
  }

  reload = () => {
    ;(this.tableInstance as $LibBugAny).fireFetchData()
  }

  loadStuff = async () => {
    this.setState(() => ({loading: true, error: undefined, loaded: false}))
    try {
      await loadHousingCorporations(this, this.getProjectId())
    } catch (e) {
      this.setState(() => ({
        loading: false,
        loaded: false,
        error: e.message || 'Some unkown error happened on the server',
      }))
    }

    this.setState(() => ({loading: false, loaded: true}))
  }

  renderModals() {
    const {state} = this

    return (
      <>
        {state.mode.mode === 'EditLocation' && (
          <EditLocationModal
            key={JSON.stringify(state.mode)}
            cid={state.mode.cid}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.loadStuff}
          />
        )}
        {state.mode.mode === 'EditComment' && (
          <EditCommentModal
            key={JSON.stringify(state.mode)}
            cid={state.mode.cid}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.loadStuff}
          />
        )}
        {state.mode.mode === 'EditName' && (
          <EditNameModal
            key={JSON.stringify(state.mode)}
            cid={state.mode.cid}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.loadStuff}
          />
        )}
        {state.mode.mode === 'EditAddress' && (
          <EditAddressModal
            key={JSON.stringify(state.mode)}
            cid={state.mode.cid}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.loadStuff}
          />
        )}
        {state.mode.mode === 'EditMunicipality' && (
          <EditMunicipalityModal
            key={JSON.stringify(state.mode)}
            cid={state.mode.cid}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.loadStuff}
          />
        )}
        {state.mode.mode === 'AddItemModal' && (
          <AddItemModal
            key="AddItemModal"
            projectId={this.getProjectId()}
            onRequestClose={() => {
              this.setState({mode: {mode: 'List'}})
            }}
            onUpdateNeeded={this.reload}
            history={this.props.history}
            projectName={this.getProjectName()}
          />
        )}
      </>
    )
  }

  render() {
    const {state} = this

    return (
      <PageLayout>
        {this.renderModals()}
        {state.loading ? (
          <div className={css.loading}>Loading...</div>
        ) : state.error ? (
          <div className={css.error}>Error: {this.state.error}</div>
        ) : (
          <div className={css.layout}>
            <div className={css.left}>{this.renderTable()}</div>
            <div className={css.right}>
              <div className={css.aboveTheMap}>
                <GenericButton
                  css={{container: css.exportButton}}
                  variant="smallRound"
                  disabled={this.state.exporting}
                  onClick={() => {
                    if (this.state.exporting) return
                    this.export()
                  }}
                >
                  Export
                </GenericButton>
              </div>
              {this.renderMap()}
            </div>
          </div>
        )}
      </PageLayout>
    )
  }

  getTrProps = (_: any, row: any) => {
    if (!row) return {}
    const {original} = row

    return {
      onClick: () => {
        this.setActiveItemIds(original._id)
      },
      onMouseOver: () => {
        this.setHoveredItemIds({[original._id]: true})
      },
      onMouseOut: () => {
        if (this.state.hoveredItemIds[original._id] === true)
          this.setHoveredItemIds({})
      },
      className:
        this.state.activeItemIds === original._id
          ? css.activeRow
          : this.state.hoveredItemIds[original._id] === true
          ? css.hoveredRow
          : '',
    }
  }

  toggleHiddenBtn = () => {
    this.setState({
      viewAllItems: !this.state.viewAllItems,
    })
  }

  toggleHidden = async (id: string) => {
    const {state} = this

    if (state.submitting) return

    const housingCorporation = this.getHousingCorporation(id)

    const hidden = !housingCorporation.isHidden()
    this.setState({submitting: true, optimisticState: hidden})

    try {
      await this.callEndpoint(editHousingCorporationHiddenState, {
        cid: id,
        hidden: hidden,
      })
    } catch (e) {
      this.setState({
        submitting: false,
        optimisticState: null,
      })

      console.log('Error editing Adjusted state')
      console.log(e)
      return
    }

    this.setState({
      submitting: false,
      optimisticState: null,
    })

    housingCorporation.toggleHidden()
  }

  getNumber(data: string) {
    // finds all numbers at the beginning of each string
    const getNumber = data.match('^[0-9]*') as string[]
    return +getNumber[0]
  }

  renderTable() {
    const listOfIds = getSnapshot(this.store.housingCorporations.list)
    const allList = listOfIds.map((id: string) =>
      // @ts-ignore
      getSnapshot(this.store.housingCorporations.byId.get(id)),
    )

    // FILTER OUT THE QUICK VALUATION ITEM
    const hideQuickValItem = allList
      .filter((item: Original['original']) => {
        if (item.name !== 'Quick Valuation') {
          return item
        } else {
          return
        }
      })
      .map((nonQVItem: Original['original']) => nonQVItem)

    // FILTER OUT THE HIDDEN ITEMS
    const nonHiddenItemsList = hideQuickValItem
      .filter((item: Original['original']) => {
        if (!item.hidden) {
          return item
        } else {
          return
        }
      })
      .map((nonHiddenItem: Original['original']) => nonHiddenItem)

    return (
      <>
        <div className={css.nameTable}>
          <div className={css.nameCell}>
            <h1 className={css.name}>{this.getProjectName()}</h1>
          </div>
        </div>

        <ReactTable
          ref={this.setTableInstance}
          data={this.state.viewAllItems ? hideQuickValItem : nonHiddenItemsList}
          className={css.table}
          getTrProps={this.getTrProps}
          defaultFilterMethod={defaultFilterMethod}
          columns={[
            {
              Header: 'Name',
              accessor: 'name',
              sortable: true,
              sortMethod: (a, b) => {
                return this.getNumber(a) > this.getNumber(b) ? 1 : -1
              },
              filterable: true,

              Cell: ({original}: Original) => {
                return original.hidden ? (
                  <div className={css.nameArchived}>{original.name}</div>
                ) : (
                  <Link
                    to={`/comparable-sales-list/${this.getProjectId()}/${this.getProjectName()}/${
                      original._id
                    }`}
                  >
                    {original.name}
                  </Link>
                )
              },
            },

            {
              Header: 'Address',
              accessor: 'address',
              sortable: true,
              filterable: true,
              Cell: ({original}: Original) => {
                return original.hidden ? (
                  <div className={css.nameArchived}>{original.address}</div>
                ) : (
                  <a
                    className={css.comment}
                    href="#"
                    onClick={() =>
                      this.setState({
                        mode: {mode: 'EditAddress', cid: original._id},
                      })
                    }
                  >
                    {original.address}
                  </a>
                )
              },
            },
            {
              Header: 'Municipality',
              accessor: 'municipality',
              sortable: true,
              filterable: true,
              Cell: ({original}: Original) => {
                return original.hidden ? (
                  <div className={css.nameArchived}>
                    {original.municipality}
                  </div>
                ) : (
                  <a
                    className={css.comment}
                    href="#"
                    onClick={() =>
                      this.setState({
                        mode: {mode: 'EditMunicipality', cid: original._id},
                      })
                    }
                  >
                    {original.municipality}
                  </a>
                )
              },
            },
            {
              Header: 'Location',
              accessor: 'location',
              filterable: true,

              sortable: false,
              Cell: ({original}: Original) => {
                const {n, e} = coordinatesToETRS(
                  original.location.lat,
                  original.location.long,
                )

                return original.hidden ? (
                  <div className={css.archivedPair}>
                    <span>{n}</span>
                    <span>{e}</span>
                  </div>
                ) : (
                  <div className={css.location}>
                    <a
                      className={css.pair}
                      href="#"
                      onClick={() =>
                        this.setState({
                          mode: {mode: 'EditLocation', cid: original._id},
                        })
                      }
                    >
                      <span>{n}</span>
                      <span>{e}</span>
                    </a>
                  </div>
                )
              },
            },
            {
              Header: 'Comment',
              accessor: 'comment',
              sortable: true,
              filterable: true,
              Cell: ({original}: Original) => {
                return original.hidden ? (
                  <div className={css.nameArchived}>{original.comment}</div>
                ) : (
                  <a
                    className={css.comment}
                    href="#"
                    onClick={() =>
                      this.setState({
                        mode: {mode: 'EditComment', cid: original._id},
                      })
                    }
                  >
                    {original.comment || ''}
                  </a>
                )
              },
            },
            {
              Header: () => {
                return (
                  <div className={css.hiddenItemContainer}>
                    <input
                      type="checkbox"
                      id="hiddenItem2"
                      name="vehicle2"
                      checked={this.state.viewAllItems}
                      onClick={() => this.toggleHiddenBtn()}
                    />
                    &nbsp;
                    <label htmlFor="hiddenItem2">
                      {this.state.viewAllItems ? 'Hide hidden' : 'Show hidden'}
                    </label>
                  </div>
                )
              },
              accessor: 'hidden',
              sortable: false,
              filterable: false,
              filterMethod: booleanFilterMethod('hidden'),
              Cell: ({original}: Original) => {
                return (
                  <div className={css.hiddenItemContainer}>
                    <input
                      type="checkbox"
                      id="hiddenItem"
                      name="vehicle1"
                      checked={original.hidden}
                      onClick={() => this.toggleHidden(original._id)}
                    />
                    &nbsp;
                    <label htmlFor="hiddenItem">
                      {original.hidden ? 'Hidden' : 'Hide item'}
                    </label>
                  </div>
                )
              },
            },
            {
              Header: '',
              accessor: 'ready',
              sortable: true,
              width: 50,
              filterable: true,
              filterMethod: booleanFilterMethod('ready'),
              Cell: ({original}: {original: {ready: boolean}}) => {
                return (
                  <div
                    className={
                      css.readyState +
                      ' ' +
                      (original.ready ? css.ready : css.notReady)
                    }
                  />
                )
              },
            },
            {
              Header: () => {
                return (
                  <div className={css.createProjectButtonContainer}>
                    <GenericButton
                      variant="round"
                      onClick={() =>
                        this.setState(() => ({
                          mode: {mode: 'AddItemModal'},
                        }))
                      }
                      css={{container: css.createProjectButton}}
                    >
                      Add item
                    </GenericButton>
                  </div>
                )
              },
              sortable: false,
              resizable: false,
              width: 200,
              Cell: ({
                original,
              }: {
                original: {_id: number; archived: string}
              }) => {
                return (
                  <div className={css.operations}>
                    <a
                      href="#"
                      className={css.operationButton}
                      onClick={() =>
                        this.setState({
                          mode: {mode: 'EditName', cid: original._id},
                        })
                      }
                    >
                      Edit Name
                    </a>
                  </div>
                )
              },
            },
          ]}
          showPagination={true}
          defaultPageSize={this.getInitialPageSize()}
          onPageSizeChange={this.onPageSizeChange}
          defaultFiltered={this.getInitialFiltered()}
          onFilteredChange={this.onFilteredChange}
          defaultSorted={this.getInitialSorted()}
          onSortedChange={this.onSortedChange}
          style={{
            height: '93vh',
          }}
        />
      </>
    )
  }

  onPageSizeChange = (pageSize: number) => {
    window.sessionStorage.setItem(
      pageSizeSessionStorageKey(this.getProjectId()),
      String(pageSize),
    )
  }

  getInitialPageSize(): number {
    const fromSession = window.sessionStorage.getItem(
      pageSizeSessionStorageKey(this.getProjectId()),
    )
    if (!fromSession) return defaultPageSize
    const parsed = parseInt(fromSession, 10)
    if (parsed > 10 && parsed < 200) {
      return parsed
    } else {
      return defaultPageSize
    }
  }

  getInitialFiltered(): Filtered {
    const def: Filtered = []

    const json = window.sessionStorage.getItem(
      filteredSessionStorageKey(this.getProjectId()),
    )

    if (!json || typeof json !== 'string') return def
    let parsed

    try {
      parsed = JSON.parse(json)
    } catch (e) {
      return def
    }

    if (!Array.isArray(parsed)) return def
    return parsed
  }

  onFilteredChange = (filtered: Filtered) => {
    window.sessionStorage.setItem(
      filteredSessionStorageKey(this.getProjectId()),
      JSON.stringify(filtered),
    )
  }

  getInitialSorted(): Sorted {
    const def: Sorted = [
      {
        id: 'name',
        desc: false,
      },
    ]

    const json = window.sessionStorage.getItem(
      sortedSessionStorageKey(this.getProjectId()),
    )

    if (!json || typeof json !== 'string') return def
    let parsed

    try {
      parsed = JSON.parse(json)
    } catch (e) {
      return def
    }

    if (!Array.isArray(parsed)) return def
    return parsed
  }

  onSortedChange = (sorted: Sorted) => {
    window.sessionStorage.setItem(
      sortedSessionStorageKey(this.getProjectId()),
      JSON.stringify(sorted),
    )
  }

  setHoveredItemIds = (hoveredItemIds: {[id: number]: true}) => {
    if (deepEqual(this.state.hoveredItemIds, hoveredItemIds)) return
    this.setState({hoveredItemIds})
  }

  setActiveItemIds = (activeItemIds: {[id: number]: true}) => {
    this.setState({
      activeItemIds:
        this.state.activeItemIds === activeItemIds ? {} : activeItemIds,
    })
  }

  renderMap() {
    const listOfIds = getSnapshot(this.store.housingCorporations.list)
    const allMarkers: any = listOfIds.map(id =>
      // @ts-ignore
      getSnapshot(this.store.housingCorporations.byId.get(id)),
    )

    // FILTER OUT THE HIDDEN ITEMS
    const nonHiddenItemsMarkers = allMarkers
      .filter((item: Original['original']) => {
        if (!item.hidden) {
          return item
        } else {
          return
        }
      })
      .map((nonHiddenItem: Original['original']) => nonHiddenItem)

    return (
      <div className={css.map}>
        <TheMap
          markers={this.state.viewAllItems ? allMarkers : nonHiddenItemsMarkers}
          activeItemIds={this.state.activeItemIds}
          hoveredItemIds={this.state.hoveredItemIds}
          setHoveredItemIds={this.setHoveredItemIds}
          setActiveItemIds={this.setActiveItemIds}
          selectedItemIds={{}}
        />
      </div>
    )
  }

  async export() {
    this.setState({exporting: true})
    await exportProjectToSpreadsheet(this, this.getProjectId())
    this.setState({exporting: false})
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/HousingCorporationsListPage.tsx